import { type GetSegmentsQueryParams } from '@gonfalon/openapi/operations/getSegments';
import type { ConstValue } from '@gonfalon/types/ConstValue';

import type { SegmentInstructionTypes } from './instructions/constants';

export enum SegmentType {
  AMPLITUDE = 'amplitude',
  REGULAR = 'regular',
  NATIVE_BIG = 'native_big',
}

export enum SyncedSegmentSourceKind {
  AMPLITUDE = 'amplitude',
  HEAP = 'heap',
  SEGMENT = 'segment',
}

type SegmentTrackEventInfo = {
  action?: string;
  bucketContextKind?: string;
  contextKind?: string;
  description?: boolean;
  filter?: string;
  filterType?: 'tag' | 'source' | 'view';
  isRelaySetup?: boolean;
  location?: string;
  syncedSource?: SyncedSegmentSourceKind;
  tags?: boolean;
  view?: string;
  type?: 'individual' | 'rule' | SegmentType;
  ruleKind?: string;
  clauseKind?: string;
  operatorName?: string;
  attributeName?: string;
  isBigSegment?: boolean;
  isExampleResource?: boolean;
};

export { type SegmentTrackEventInfo };

export type UISegmentsListView = {
  sort?: GetSegmentsQueryParams['sort'];
  query?: string;
  keys?: string[];
  tags?: string[];
  kind?: string;
};

export type SegmentInstructionType = ConstValue<typeof SegmentInstructionTypes>;
export type InstructionType = SegmentInstructionType;
